import Vue from 'vue'

function translateClip(clip) {
  const {
    Id: id,
    Title: title,
    Description: description,
    AudioUrl: audioUrl,
    DurationSeconds: duration,
    ImageUrl: imageUrl,
    ProgramId: programId,
    PublishedUtc: publishedUtc
  } = clip

  return {
    id,
    title,
    description,
    audioUrl,
    duration,
    imageUrl,
    programId,
    publishedUtc
  }
}

export default {
  namespaced: true,
  state: {
    playlists: {},
    clips: {},
    programs: {},
    programLoading: {}
  },
  mutations: {
    SET_PLAYLIST_DATA(state, playlist) {
      Vue.set(state.playlists, playlist.id, {
        ...playlist,
        clips: []
      })
    },

    SET_CLIP_DATA(state, clip) {
      Vue.set(state.clips, clip.id, clip)
    },

    SET_PLAYLIST_CLIPS(state, {playlistId, clips}) {
      Vue.set(state.playlists[playlistId], 'clips', clips)
    },

    PROGRAM_LOADING(state, programId) {
      Vue.set(state.programLoading, programId, true)
    },

    SET_PROGRAM_DATA(state, program) {
      Vue.set(state.programs, program.id, program)
      Vue.delete(state.programLoading, program.id)
    }
  },
  actions: {
    async fetchPlaylistData({commit, dispatch}, apiUrl) {
      const response = await fetch(apiUrl)
      const { Id: id, Title: title, Description: description, ArtworkUrl: imageUrl, OrganizationId: orgId} = await response.json()

      commit('SET_PLAYLIST_DATA', {
        id,
        title,
        description,
        imageUrl
      })

      dispatch('fetchClips', {orgId, playlistId: id})
      
      return id
    },

    async fetchClipData({commit, dispatch}, apiUrl) {
      const response = await fetch(apiUrl).then(res => res.json())
      const clip = translateClip(response)
      const orgId = response.OrganizationId

      commit('SET_CLIP_DATA', clip)
      dispatch('fetchPrograms', {orgId, programIds: [clip.programId]})

      return clip.id
    },

    async fetchClips({commit, dispatch}, {orgId, playlistId}) {
      const response = await fetch(`https://omny.fm/api/orgs/${orgId}/playlists/${playlistId}/clips`)
      const { Clips: rawClips } = await response.json()
      const clips = rawClips.map(translateClip)

      commit('SET_PLAYLIST_CLIPS', {playlistId, clips})
      dispatch('fetchPrograms', {orgId, programIds: clips.map(clip => clip.programId)})
    },

    async fetchPrograms({commit, state}, {orgId, programIds}) {
      for (const programId of programIds) {
        // Make sure we only start loading once
        if (state.programs[programId] || state.programLoading[programId]) { continue }

        commit('PROGRAM_LOADING', programId)
        const response = await fetch(`https://omny.fm/api/orgs/${orgId}/programs/${programId}`)
        const {
          Id: id,
          Name: name
        } = await response.json()

        commit('SET_PROGRAM_DATA', {
          id,
          name
        })
      }
    }
  }
}